import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	detailModal: false,
	detailContent: null,
	deletingItem: null,
};

export const usersSlice = createSlice({
	name: "users",
	initialState,
	reducers: {
		changeDetailModal: (state, action) => {
			state.detailModal = action.payload ?? !state.detailModal;
		},
		changeDetailContent: (state, action) => {
			state.detailContent = action.payload;
		},
		changeDeletingItem: (state, action) => {
			state.deletingItem = action.payload;
		},
		resetUsersSlice: () => initialState,
	},
});

export const {
	changeDetailModal,
	changeDetailContent,
	changeDeletingItem,
	resetUsersSlice,
} = usersSlice.actions;
export default usersSlice.reducer;
